import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "917011702848";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hi North Stack, I'd like to discuss a performance marketing project."
)}`;

const WhatsAppWidget = () => {
  return (
    <motion.a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: "spring", stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 left-6 z-50 w-14 h-14 rounded-full bg-[#25D366] shadow-[0_8px_30px_rgba(37,211,102,0.45)] flex items-center justify-center group"
      data-testid="whatsapp-widget-float"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></span>
      <MessageCircle className="w-7 h-7 text-white fill-white relative z-10" />
      <span className="absolute right-full mr-3 whitespace-nowrap bg-[#0F1419] text-white text-sm font-medium px-3 py-2 rounded-lg border border-white/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat on WhatsApp
      </span>
    </motion.a>
  );
};

export default WhatsAppWidget;
